import { useEffect } from 'react';

export async function wait(time = 1000): Promise<void> {
  return new Promise((res) => setTimeout(res, time));
}

export function getParameterByName(name: string, url = window.location.href): string | undefined {
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) {
    return;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (typeof value !== 'object' || value === null) return false;

  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
};

export type OptionalErrorResponseTuple<R, E = Error> = [E, null] | [null, R];

export function useInterval(callback: () => void, delay: number) {
  useEffect(() => {
    callback();
    const intervalId = window.setInterval(callback, delay);
    return () => window.clearInterval(intervalId);
  }, [callback, delay]);
}
